import React from 'react'
import cn from 'classnames'

import styles from './relationPill.scss'

interface IProps {
  type: string
  count?: number
  isList?: boolean
  isNull?: boolean
  isPressed?: boolean
  onClick?: () => void
}

export default class RelationPill extends React.Component<IProps> {
  render() {
    const {
      type,
      count = 0,
      isList = false,
      isNull = false,
      isPressed = false,
      onClick,
    } = this.props
    return (
      <div
        data-cy="relation-pill"
        data-cy-null={`${isNull}`}
        className={cn(styles.pill, {
          [styles.isNull]: isNull,
          [styles.isPressed]: isPressed,
        })}
        onClick={onClick}
      >
        {isList && <span className={styles.count}>{count}</span>}
        <span className={styles.modelName}>{type}</span>
      </div>
    )
  }
}
